import { Box, Grid, MenuItem, Typography } from "@mui/material";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import Label from "../../../components/label";
import CustomDropDown from "../../../components/select";
import TextInput from "../../../components/textInput";
import { AppContext } from "../../../lib/Context";

const routerList = [0, 1, 2, 3];
const COST_TYPE = [
  {
    value: "One Of Cost",
    type: "oneOfCost",
  },
  {
    value: "Monthly",
    type: "monthly",
  },
];

const CordedlessPhone = () => {
  const location = useLocation();
  const isDetailPage = location.pathname === "/prospect-details";
  const { cordedlessPhone, setCordlessPhone } = useContext(AppContext);

  const handleCordedlessPhoneValueChange = (e) => {
    const newValue = e.target.value;
    setCordlessPhone((prev) => ({
      ...prev,
      price:
        cordedlessPhone.costType === "oneOfCost"
          ? newValue * 30
          : newValue * 1.5,
      value: newValue,
    }));
  };

  const handleEditCordedlessPhoneCharges = (e) => {
    const newValue = parseFloat(e.target.value);

    const forOneOfCost =
      cordedlessPhone.costType === "oneOfCost" &&
      newValue > cordedlessPhone.value * 100;

    const forMonthly =
      cordedlessPhone.costType === "monthly" &&
      newValue > cordedlessPhone.value * 10000;

    if (newValue < 0 || forOneOfCost || forMonthly) {
      return;
    }

    setCordlessPhone((prev) => ({
      ...prev,
      price: newValue,
    }));
  };

  const handleCordlessCostTypeChange = (e) => {
    const newValue = e.target.value;
    setCordlessPhone((prev) => ({
      ...prev,
      costType: newValue,
      value: 0,
      price: 0,
    }));
  };

  return (
    <Box mt={2} mb={5}>
      <Typography variant="h6" color={"text.charcoalGrey"}>
        Cordless Phones
      </Typography>
      <Grid container mt={0} spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Cost Type"} />
          <CustomDropDown
            variant={"filled"}
            value={cordedlessPhone.costType}
            onChange={handleCordlessCostTypeChange}
            readonly={isDetailPage}
          >
            {COST_TYPE.map((val, ind) => (
              <MenuItem key={ind} value={val.type}>
                {val.value}
              </MenuItem>
            ))}
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"No. of Cordless Phones"} />
          <CustomDropDown
            variant={"filled"}
            value={cordedlessPhone.value}
            onChange={handleCordedlessPhoneValueChange}
            readonly={isDetailPage}
          >
            {routerList.map((val, ind) => (
              <MenuItem key={ind} value={val}>
                {val}
              </MenuItem>
            ))}
          </CustomDropDown>
        </Grid>
        {cordedlessPhone.value > 0 && (
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Total Cost"} htmlFor={"cordedless-phone-charges"} />
            <TextInput
              id={"cordedless-phone-charges"}
              variant={"filled"}
              required
              type={"number"}
              value={cordedlessPhone.price}
              onChange={handleEditCordedlessPhoneCharges}
              readonly={isDetailPage}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default CordedlessPhone;
